import { render, staticRenderFns } from "./CreateWebhook.vue?vue&type=template&id=01b7d37a&scoped=true&"
import script from "./CreateWebhook.vue?vue&type=script&lang=ts&"
export * from "./CreateWebhook.vue?vue&type=script&lang=ts&"
import style0 from "./CreateWebhook.vue?vue&type=style&index=0&id=01b7d37a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b7d37a",
  null
  
)

export default component.exports